import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ConfigContext = createContext({ calendlyUrl: "", emailConfigured: false, api: API });

export const useConfig = () => useContext(ConfigContext);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ calendlyUrl: "", emailConfigured: false });

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/config`)
      .then((res) => { if (active) setConfig(res.data); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    <ConfigContext.Provider value={{ ...config, api: API }}>
      {children}
    </ConfigContext.Provider>
  );
}
